import type { ValidationError } from './validation-error-types';
import { zodIssuesToValidationErrors } from './zod-to-validation-errors';

import { businessAddressSchema } from '../../model/schemas';

export function validateRegisteredAddress(
  value: unknown,
  shouldSkipEmpty = true
): ValidationError[] {
  if (!value && shouldSkipEmpty) return [];
  const result = businessAddressSchema.safeParse(value);
  if (result.success) return [];
  return zodIssuesToValidationErrors(result.error.issues);
}
